/**
 * wexin配置
 */

import qs from 'qs';
import { useRef } from 'react';
import { Request } from '@medlinker/apitool/request';
import env from '../../utils/env';
import useDidMount from '../useDidMount';
import request from '../../request';
import { hosts } from '../../constants';

const ENTRY_URL = window.location.href.split('#')[0];

// 防止循环引用问题，做成懒加载
let req: Request<any, any, any> | null = null;
let isReady = false;
let callbacks: Array<(val: any) => void> = [];
let index = 0;
let resolve: any = () => {};
let reject: any = () => {};
let promise = new Promise(r => (resolve = r));

const share = (shareConfig?: any) => {
  if (typeof wx === 'undefined') return;

  const defaultShareConfig = {
    title: `【医联分享】${document.title}`,
    desc: '医联健康 - 国内领先的专科疾病管理平台',
    link: location.href.split('#')[0],
    imgUrl: process.env.MED_PUBLIC_URL + 'static/logo.png',
    success: function () {},
  };

  shareConfig = {
    ...defaultShareConfig,
    link: location.href.split('#')[0],
    ...shareConfig,
  };

  if (shareConfig.imgUrl) {
    if (!shareConfig.imgUrl.match(/^(http(s?):)?\/\//i)) {
      shareConfig.imgUrl = window.location.origin + shareConfig.imgUrl;
    }
  }

  // @ts-ignore
  wx.onMenuShareTimeline(shareConfig);
  // @ts-ignore
  wx.onMenuShareAppMessage(shareConfig);
  // @ts-ignore
  wx.onMenuShareQQ(shareConfig);
  // @ts-ignore
  wx.onMenuShareQZone(shareConfig);
  // @ts-ignore
  wx.updateAppMessageShareData(shareConfig);
  // @ts-ignore
  wx.updateTimelineShareData(shareConfig);
};

export const wxSdkSign = () => {
  if (typeof wx === 'undefined') return;
  isReady = false;
  const cIndex = ++index;

  callbacks = [];
  promise = new Promise((r, j) => {
    resolve = r;
    reject = j;
  });
  if (req) {
    req.cancel();
  }

  req = request.get<{ url: string; type?: string }, any>('/wx/config-data', {
    baseURL: hosts.AUTH,
  });

  req
    .setParams({
      type:
        (qs.parse(location.search, { ignoreQueryPrefix: true })
          ._opentype as string) || (env.appEnv === 'prod' ? 'trans' : 'test'),
      url: env.isIos ? ENTRY_URL : location.href.split('#')[0],
    })
    .then(data => {
      wx.config({
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [
          // 为什么加这，因为首页和商城首页就需要，所以必须一开始就要授权功能
          // @ts-ignore
          'getLocation',
          'chooseWXPay',
          // @ts-ignore
          'onMenuShareAppMessage',
          // @ts-ignore
          'onMenuShareTimeline',
          // @ts-ignore
          'onMenuShareQQ',
          'onMenuShareQZone',
          'updateAppMessageShareData',
          'updateTimelineShareData',
        ],
        openTagList: ['wx-open-launch-weapp'],
      });

      resolve(data);

      wx.ready(() => {
        if (index !== cIndex) return;
        isReady = true;
        share();
        callbacks.forEach(item => item(wx));
        callbacks = [];
      });
    })
    .catch(e => {
      reject(e);
    });
};

/**
 * @deprecated 请使用 `usePageConfig`
 */
export default (
  jsApiList?: any,
  hideMenuItems?: any,
  errorHandler?: (e: any) => void
) => {
  useDidMount(() => {
    if (jsApiList && jsApiList.length) {
      promise
        .then((data: any) => {
          if (typeof wx === 'undefined') return;

          // @ts-ignore
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
              ...jsApiList,
              // 为什么加这，因为首页和商城首页就需要，所以必须一开始就要授权功能
              // @ts-ignore
              'getLocation',
              // @ts-ignore
              'onMenuShareAppMessage',
              // @ts-ignore
              'onMenuShareTimeline',
              // @ts-ignore
              'onMenuShareQQ',
              'onMenuShareQZone',
              'updateAppMessageShareData',
              'updateTimelineShareData',
            ],
            openTagList: ['wx-open-launch-weapp'],
          });
        })
        .catch(e => errorHandler && errorHandler(e));
    }

    return () => {
      isReady = false;
    };
  });

  return useRef({
    ready(callback: (wx: any) => any) {
      if (typeof wx === 'undefined') return;

      if (isReady) {
        callback(wx);
      } else {
        callbacks.push(callback);
      }
    },
    share(config?: any) {
      this.ready(() => share(config));
    },
  }).current;
};
